"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _reactSelect = require("react-select");
var _lodash = require("lodash");
var _MenuList = _interopRequireDefault(require("./MenuList"));
var _Option = _interopRequireDefault(require("./Option"));
var _color = require("./color");
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class MultiSelectDropdown extends _react.Component {
  constructor() {
    var _this$props, _this$props2;
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      value: ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.defaultValue) || [],
      invalidValues: [],
      inputValue: "",
      options: (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.options,
      isValidNewOption: false,
      noOptionsMessage: ""
    });
    (0, _defineProperty2.default)(this, "selectRef", /*#__PURE__*/(0, _react.createRef)(null));
    (0, _defineProperty2.default)(this, "onChange", option => {
      const {
        name,
        setValue,
        getValues,
        getValue,
        getSelectedValues
      } = this.props;
      this.setState({
        value: option,
        isValidNewOption: false
      });
      if (name && setValue) {
        setValue(name, option);
        /* istanbul ignore else */
        if (getValue) {
          getValue(getValues(name));
        }
      }
      if (getSelectedValues) getSelectedValues(option);
    });
    (0, _defineProperty2.default)(this, "handleInputChange", inputValue => {
      var _this$selectRef$curre, _this$props3;
      if ((_this$selectRef$curre = this.selectRef.current) !== null && _this$selectRef$curre !== void 0 && _this$selectRef$curre.inputRef.checkValidity() && inputValue.length !== 0) {
        const {
          validateMaxLength,
          maxLength
        } = this.props;
        if (validateMaxLength) {
          if (inputValue.length > maxLength) {
            const {
              maxLengthErrorMsg
            } = this.props;
            this.setState({
              isValidNewOption: false,
              noOptionsMessage: maxLengthErrorMsg
            });
          } else {
            this.setState({
              isValidNewOption: true,
              noOptionsMessage: ""
            });
          }
        } else {
          this.setState({
            isValidNewOption: true,
            noOptionsMessage: ""
          });
        }
      } else {
        const {
          patternError
        } = this.props;
        this.setState({
          isValidNewOption: false,
          noOptionsMessage: inputValue.length !== 0 ? patternError : ""
        });
      }
      this.setState({
        inputValue
      });
      if ((_this$props3 = this.props) !== null && _this$props3 !== void 0 && _this$props3.isValidNewOption && !this.props.isValidNewOption()) {
        if (inputValue) {
          this.setState({
            noOptionsMessage: "".concat(inputValue, " is not an allowed value")
          });
        } else {
          this.setState({
            noOptionsMessage: "No options"
          });
        }
      }
    });
    (0, _defineProperty2.default)(this, "createNewOption", inputValues => {
      const {
        name,
        setValue,
        getValues,
        getValue,
        getSelectedValues
      } = this.props;
      const {
        options
      } = this.state;
      const newOptions = inputValues.map(data => {
        return {
          label: data,
          value: data
        };
      });
      this.setState({
        options: (0, _lodash.sortBy)([...options, ...newOptions], ["value"]),
        value: [...this.state.value, ...newOptions],
        isValidNewOption: false
      });
      if (name && setValue && getValues) {
        setValue(name, [...getValues(name), ...newOptions]);
        /* istanbul ignore else */
        if (getValue) {
          getValue(getValues(name));
        }
      }
      if (getSelectedValues) {
        getSelectedValues([...this.state.value, ...newOptions]);
      }
    });
    (0, _defineProperty2.default)(this, "handleCreate", async inputValue => {
      const {
        asyncFunToCrtOption
      } = this.props;
      let response;
      if (asyncFunToCrtOption) {
        typeof inputValue === "string" ? response = await asyncFunToCrtOption([inputValue]) : response = await asyncFunToCrtOption(inputValue);
        if (response.hasOwnProperty("error")) {
          return;
        } else {
          this.createNewOption(response);
        }
      } else {
        this.createNewOption([inputValue]);
      }
    });
  }
  componentDidUpdate(prevProps) {
    var _this$props4, _prevProps$options;
    const {
      name,
      setValue
    } = this.props;
    if (((_this$props4 = this.props) === null || _this$props4 === void 0 || (_this$props4 = _this$props4.options) === null || _this$props4 === void 0 ? void 0 : _this$props4.length) !== (prevProps === null || prevProps === void 0 || (_prevProps$options = prevProps.options) === null || _prevProps$options === void 0 ? void 0 : _prevProps$options.length) && setValue) {
      var _this$props5;
      setValue(name, []);
      this.setState({
        value: [],
        options: (_this$props5 = this.props) === null || _this$props5 === void 0 ? void 0 : _this$props5.options
      });
    }
  }
  componentDidMount() {
    var _this$props6, _this$props7, _this$selectRef$curre3;
    const {
      options
    } = this.state;
    const {
      name,
      getValues,
      createable,
      allowAll
    } = this.props;
    if ((_this$props6 = this.props) !== null && _this$props6 !== void 0 && _this$props6.isValidNewOption && !this.props.isValidNewOption()) {
      this.setState({
        noOptionsMessage: (0, _lodash.isEmpty)(options) ? "No options" : "Already selected all the options"
      });
    }
    if ((_this$props7 = this.props) !== null && _this$props7 !== void 0 && _this$props7.pattern) {
      var _this$selectRef$curre2, _this$props8;
      (_this$selectRef$curre2 = this.selectRef.current) === null || _this$selectRef$curre2 === void 0 || _this$selectRef$curre2.inputRef.setAttribute("pattern", (_this$props8 = this.props) === null || _this$props8 === void 0 ? void 0 : _this$props8.pattern);
    }
    (_this$selectRef$curre3 = this.selectRef.current) === null || _this$selectRef$curre3 === void 0 || _this$selectRef$curre3.inputRef.addEventListener("paste", event => {
      var _this$selectRef$curre4;
      let validItems = [];
      let invalidItems = [];
      let bulkCreateItems = [];
      /* istanbul ignore next */
      const paste = (event.clipboardData || window.clipboardData).getData("text");
      // find only valid options
      let pastedItems = paste.split("\n").filter(t => "".concat(t).trim().length > 0);

      // trim the white-spaces
      pastedItems = (0, _lodash.map)(pastedItems, _lodash.trim);
      // prep uniq array
      pastedItems = (0, _lodash.uniqBy)(pastedItems, _lodash.toLower);
      const {
        validateMaxLength
      } = this.props;
      // create valid already exist, valid but not exist and invalid list
      pastedItems.map(item => {
        const findMatch = (0, _lodash.find)(this.state.options, option => {
          return (0, _lodash.toLower)(item) === (0, _lodash.toLower)(option.label);
        });
        if (findMatch || createable) {
          validItems.push(findMatch);
        } else {
          var _this$props9;
          if (allowAll && item.length !== 0 && new RegExp("^".concat((_this$props9 = this.props) === null || _this$props9 === void 0 ? void 0 : _this$props9.pattern, "$")).test(item)) {
            if (validateMaxLength) {
              const {
                maxLength
              } = this.props;
              if (item.length <= maxLength) {
                bulkCreateItems.push(item);
              } else {
                invalidItems.push(item);
              }
            } else {
              bulkCreateItems.push(item);
            }
          } else {
            invalidItems.push(item);
          }
        }
      });
      if (allowAll && !(0, _lodash.isEmpty)(bulkCreateItems)) {
        this.handleCreate(bulkCreateItems);
      }
      if (getValues) {
        validItems = (0, _lodash.uniqBy)([...getValues(name), ...validItems], _ref => {
          let {
            value
          } = _ref;
          return (0, _lodash.toLower)(value);
        });
      } else {
        var _this$state;
        validItems = (0, _lodash.uniqBy)([...((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.value), ...validItems], _ref2 => {
          let {
            value
          } = _ref2;
          return (0, _lodash.toLower)(value);
        });
      }
      event.preventDefault();
      this.setState({
        invalidValues: invalidItems,
        isValidNewOption: false
      });
      if (validItems.length >= 1) {
        event.preventDefault();
        // Calling change event on my state
        this.onChange(validItems);
      }

      // hide the options on paste so that warning message is visible
      (_this$selectRef$curre4 = this.selectRef.current) === null || _this$selectRef$curre4 === void 0 || _this$selectRef$curre4.inputRef.blur();
      setTimeout(() => {
        var _this$selectRef$curre5;
        (_this$selectRef$curre5 = this.selectRef.current) === null || _this$selectRef$curre5 === void 0 || _this$selectRef$curre5.inputRef.focus();
      }, 500);
    });
  }
  render() {
    const {
      options,
      value,
      inputValue,
      invalidValues,
      isValidNewOption,
      noOptionsMessage
    } = this.state;
    const {
      copyPastWarningMsg,
      validateMaxLength,
      maxLengthErrorMsg,
      showForm
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "multi-select-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_creatable.default, (0, _extends2.default)({
      styles: _color.colourStyles,
      value: value,
      inputValue: inputValue,
      ref: this.selectRef,
      onInputChange: this.handleInputChange,
      onCreateOption: this.handleCreate,
      isValidNewOption: () => isValidNewOption,
      noOptionsMessage: () => noOptionsMessage || "Type something new and press enter to create.",
      className: "px-multi-select ".concat(!(0, _lodash.isEmpty)(invalidValues) ? "is-invalid" : ""),
      classNamePrefix: "multi-select",
      components: {
        MenuList: _MenuList.default,
        Option: _Option.default
      },
      captureMenuScroll: false,
      filterOption: (0, _reactSelect.createFilter)({
        ignoreAccents: false
      }),
      tabSelectsValue: false
    }, this.props, {
      onChange: this.onChange,
      options: options
    })), !(0, _lodash.isEmpty)(invalidValues) && /*#__PURE__*/_react.default.createElement("p", {
      className: "text-warning form--control__error"
    }, validateMaxLength ? maxLengthErrorMsg : copyPastWarningMsg, ":", " ", (0, _lodash.toString)(invalidValues)), showForm && /*#__PURE__*/_react.default.cloneElement(showForm));
  }
}
exports.default = MultiSelectDropdown;
MultiSelectDropdown.defaultProps = {
  defaultValue: null,
  options: [],
  isMulti: false,
  isSearchable: false,
  isClearable: false,
  placeholderText: "Select",
  asyncFunToCrtOption: null,
  allowAll: false,
  copyPastWarningMsg: "Removed invalid option(s)",
  validateMaxLength: false
};
MultiSelectDropdown.propTypes = {
  /** Provides default selection for dropdown */
  defaultValue: _propTypes.default.array,
  /** Set to true, it allows to clear all selections at once.  */
  isClearable: _propTypes.default.bool,
  /** Set to true, it allows to select multiple options. */
  isMulti: _propTypes.default.bool,
  /** Set to true, it allows to search between options. */
  isSearchable: _propTypes.default.bool,
  /** Array of options that populate the drop-down menu. */
  options: _propTypes.default.array,
  /** Specifies placeholder text */
  placeholderText: _propTypes.default.string,
  /** RegEx to ignore the character. (Characters which are not allowed) */
  regexInvalidChar: _propTypes.default.string,
  /** Async function to be called on save the new option on the server */
  asyncFunToCrtOption: _propTypes.default.func,
  /**set to true, it allow to create multiple options by copy paste event  */
  allowAll: _propTypes.default.bool,
  /** set the user defined warning msg for invalid option for copy paste */
  copyPastWarningMsg: _propTypes.default.string,
  /** Validate the maxlength while creating new option */
  validateMaxLength: _propTypes.default.bool,
  /** maxlength for creating new option */
  maxLength: _propTypes.default.number,
  /** set the user defined warning msg for maxlength exceeds when creating new option */
  maxLengthErrorMsg: _propTypes.default.string
};